import type { RouteRecordRaw } from 'vue-router';

export const qaRoutes: Array<RouteRecordRaw> = [
  {
    path: '/qa',
    name: 'qa',
    redirect: '/qa/test',
    component: () => import('pages/central/qa/QaTest.vue'),
    meta: {
      title: 'Quality Assurance - Release Testing',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/qa/test',
    name: 'qaTest',
    redirect: '/qa/test/list',
    component: () => import('pages/central/qa/QaTest.vue'),
    meta: {
      title: 'Quality Assurance - Release Testing',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'qaTestList',
        component: () => import('pages/central/qa/QaTestList.vue'),
        meta: {
          title: 'Testings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'qaTestDetail',
        component: () => import('pages/central/qa/QaTestDetail.vue'),
        meta: {
          title: 'Quality Assurance - Testing Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'qaTestNew',
        component: () => import('pages/central/qa/QaTestNew.vue'),
        meta: {
          title: 'Quality Assurance - New Testing',
          requiresAuth: true,
        },
      },
      // {
      //   path: 'explorer',
      //   name: 'qaTestExplorer',
      //   component: () => import('pages/central/qa/QaExplorerDtable.vue'),
      //   meta: {
      //     title: 'Testings Explorer',
      //     requiresAuth: true,
      //   },
      // },
    ],
  },
];
